import { Services } from "../../services/Services.js";
import { Editor } from "./Editor.js";

export class TextBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            onFormatValue = null,
            onParseValue = null,
            multiline = false,
            autofocus = false,
            expanable = false,
            expanded = false
        } = options;

        this.onFormatValue = onFormatValue;
        this.onParseValue = onParseValue;
        this.multiline = multiline;
        this.autofocus = autofocus;
        this.expanable = expanable;
        this.expanded = expanded;

    };

    isMultiline() {

        return (typeof this.multiline === 'function') ? this.multiline.call(this) : this.multiline;

    };

    isExpandable() {

        return (typeof this.expandable === 'function') ? this.expandable.call(this) : this.expandable;

    };

    isExpanded() {

        return this.expanded;

    };

    isAutofocus() {

        return (typeof this.autofocus === 'function') ? this.autofocus.call(this) : this.autofocus;

    };

    render(vm) {

        const ct = Services.get('templates');

        var that = this,
            value = this.getValue(),
            style = this.getCss(),
            props = {
                id: this.getId(),
                visible: this.isVisible(),
                onchange: onValueChange,
                'data-focus': !(this.isDisabled() || this.isReadOnly()) && this.isAutofocus() ? 'auto' : null,
            },
            params = {
                expandable: this.isExpandable(),
                expanded: this.isExpanded(),
                ontoggleclick: onToggleClick,
            },
            oldValue = '';

        if (this.isReadOnly() || this.isDisabled()) {
            if (this.isMultiline())
                props.disabled = true;
            else
                props.readonly = 'readonly';
        }

        if (typeof this.onFormatValue == 'function')
            value = this.onFormatValue(value);

        if (this.immediateValueChange) {
            //props.onkeydown = onValuePossibleChange;
            props.onkeyup = onValuePossibleChange;
        }

        if (this.isMultiline()) {
            if (this.isExpandable())
                return ct.textAreaEx(value, style, props, params);
            return ct.textArea(value, style, props);
        }
        return ct.textBox(value, style, props, params);

        function onValueChange(e, node) {
            var value = e.target.value;
            if (typeof that.onParseValue == 'function')
                value = that.onParseValue(value);
            that.changeValue(value);
        };

        function onValuePossibleChange(e, node) {
            var value = e.target.value;
            if (value == oldValue)
                return;
            oldValue = value;
            that.changeValue(value);
        };

        function onToggleClick(e) {

            that.expanded = !that.expanded;
            vm.invalidate();

        };

    };

}